import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ContentContext } from "../contexts/ContentContext";
import { FiArrowRight } from "react-icons/fi";
import BrandMark from "./BrandMark";

export default function CTASection() {
    const { data } = useContext(ContentContext);
    return (
        <section className="py-20 bg-gradient-to-br from-gold-50 via-white to-navy-50">
            <div className="max-w-5xl mx-auto px-6 lg:px-8">
                <div className="relative gradient-navy rounded-3xl p-10 md:p-16 text-center overflow-hidden">
                    {/* Pattern + glow accents */}
                    <div className="absolute inset-0 brand-pattern-light opacity-30 pointer-events-none" />
                    <div className="absolute -top-20 -right-20 w-72 h-72 bg-gold-400/25 rounded-full blur-3xl" />
                    <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-brand-leaf/25 rounded-full blur-3xl" />

                    <div className="relative">
                        <div className="flex justify-center mb-6">
                            <BrandMark className="w-16 h-16 float-slow" />
                        </div>
                        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-4">
                            {data.cta.title}
                        </h2>
                        <p className="text-lg text-white/85 mb-8 max-w-2xl mx-auto">
                            {data.cta.subtitle}
                        </p>
                        <Link
                            to="/contact"
                            className="inline-flex items-center gap-2 px-8 py-4 bg-gold-400 hover:bg-gold-300 text-navy-900 font-semibold rounded-lg transition shadow-soft hover:shadow-glow"
                        >
                            {data.cta.button}
                            <FiArrowRight className="rtl:rotate-180" />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
